import script from "./ProductDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./ProductDisplay.vue?vue&type=style&index=0&id=61d3a85c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d3a85c"]])

export default __exports__